let headings = {
    business: { 
        text: 'Business Contact Information',
        added: false
        },
    principals: { 
        text: 'Principals (Owners and Decision Makers)' ,
        added: false,
    },
    shipping: { 
        text: 'Shipping Instructions',
        added: false
        }
};

const createStyledHeading = (text) => {
    const heading = document.createElement('h1');
    heading.textContent = text;
    heading.className = 'register-form-heading';
    heading.style.cssText = `
        color: var(--1-Deep-Green, #2B3729);
        text-align: center;
        font-family: var(--font-heading-family);
        font-size: 38px;
        font-style: normal;
        font-weight: 700;
        line-height: 48px;
        letter-spacing: -0.76px;
        margin: 42px 0 32px 0;
    `;
    return heading;
};



const applyFormStyles = (shadowRoot) => { 
    const body = document.body;
    let storeColor = '#8A0016';  
    
    if (body.classList.contains('store-lax')) {
        storeColor = '#797e65';  
    } else if (body.classList.contains('store-xtreme')) {
        storeColor = '#A61B1B';  
    } else if (body.classList.contains('store-ammo-load')) {
        storeColor = '#285287'; 
    }
    const style = document.createElement('style');
    style.textContent = `
        #form-container-ref section[data-sizing="form-wrapper"] {
            max-width: 90%;
            margin: 0 auto;
            padding: 0 80px!important;
            width: -webkit-fill-available;
        } 

        @media (max-width: 750px) {
            #form-container-ref section[data-sizing="form-wrapper"] {
                max-width: 100% !important;
                padding: 0 0px !important;
            }
        }

        #form-container-ref section[data-sizing="form-wrapper"] form {
          max-width: 100%;
          padding: 0 ;
            margin: 0 auto;
            width: 100%;
            gap: 32px !important;
            box-sizing: border-box !important;
            overflow-x: hidden !important;
        }
        @media (max-width: 1399px) and (min-width: 1101px) {
           h2[class^="_textHeading_"] {
                font-family: Playfair !important;
                color: #2B3729 !important; 
                font-weight: 700;
                font-size: 40px!important;
                line-height: 48px!important;
                text-align: start !important;
            }
            #form-container-ref section[data-sizing="form-wrapper"] form {
                width: 90%!important;
                padding: 0 0!important;
            }
        }
 
            ._formError_1mxsl_21 {
                line-height: 16px !important;
                position: absolute !important;
                bottom: -22px !important;
                left: 0 !important;
                width: 100% !important;
                margin: 0 !important;
            }
        ._formFieldContainer_1ydxd_5 {
            margin-bottom: 20px;
        } 
      ._textBody_2aowh_10._checkboxLegend_1hja3_20 {
           color: var(--Black-Shades-200, #212124);
            font-family: "Helvetica Neue";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; /* 150% */
        }
         ._textBody_2aowh_10{
            color: var(--Black-Shades-200, #212124)!important;
            font-family: "Helvetica Neue";
            font-size: 13px!important;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; 
        }
        
        /* Checkbox layout - 2 columns on desktop */
        div[class^="_verticalLayout_"] {
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 16px !important;
        }
        
        @media (min-width: 1300px) {
            div[class^="_verticalLayout_"] {
                grid-template-columns: 1fr 1fr !important;
                gap: 16px 32px !important;
            }
            ._textBody_2aowh_10{
                color: var(--Black-Shades-200, #212124)!important;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; 
            }
        }
        
        /* Checkbox styling */
        input[class^="_checkboxInput_"],
        input[type="checkbox"][class^="_checkboxInput_"] {
            appearance: none !important;
            -webkit-appearance: none !important;
            -moz-appearance: none !important;
            background: transparent !important;
            background-color: transparent !important;
            border: 2px solid #000000 !important;
            width: 20px !important;
            height: 20px !important;
            border-radius: 4px !important;
            cursor: pointer !important;
            position: relative !important;
            flex-shrink: 0;
        }
        
        input[class^="_checkboxInput_"]:checked,
        input[type="checkbox"][class^="_checkboxInput_"]:checked {
            background: #285287 !important;
            background-color: #285287 !important;
            border: 2px solid #285287 !important;
        }
        
        input[class^="_checkboxInput_"]:checked::after,
        input[type="checkbox"][class^="_checkboxInput_"]:checked::after {
            content: "" !important;
            position: absolute !important;
            left: 4px !important;
            top: 0px !important;
            width: 6px !important;
            height: 10px !important;
            border: 2px solid white !important;
            border-width: 0 2px 2px 0 !important;
            transform: rotate(45deg) !important;
        }
        ._error_1o4ef_1 {
            position: absolute !important;
            bottom: -22px !important;
            left: 0 !important;
            width: 100% !important;
            margin: 0 !important;
        }
        @media (max-width: 749px) {
            ._formError_1mxsl_21 {
                bottom: -17px !important;
            }
        }
        [class^="_textBody_"] p,
         [class^="_textBody_"] p a{
            color:  #212121 !important;
            text-align: center;
                    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 18px !important;
            font-style: normal;
            font-weight: 400;
            line-height: 28px; 
            letter-spacing: 0.1px !important;
        }

        section[class^="_formHeader_"] {
           margin: 0px auto 24px auto !important;
        }

       @media (min-width:1400px) {
            h2[class^="_textHeading_"] {
                font-family: Playfair !important;
                color: #2B3729 !important; 
                font-weight: 700;
                font-size: 48px !important;
                font-style: normal !important;
                font-weight: 700 !important;
                line-height: 60px !important;
                letter-spacing: -0.96px !important;
                text-align: start !important;
            }
        }

        div[class^="_formFieldContainer_"] input,
        div[class^="_formFieldContainer_"] select {
            padding: 22px 14px 8px 14px !important;
            border: 0.5px solid #484848 !important;
            border-radius: 8px !important;
            background: #F6F5F2 !important;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
            box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05) !important;
            box-sizing: border-box !important;
            height: 44px !important;
            max-height: 44px !important;
        }

        div[class^="_formFieldContainer_"] textarea {
            padding: 22px 14px 8px 14px !important;
            border: 0.5px solid #484848 !important;
            border-radius: 8px !important;
            background: transparent !important;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
            box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05) !important;
            box-sizing: border-box !important;
            height: 166px !important;
        }

        div[class^="_formFieldContainer_"] select {
            appearance: none !important;
            background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 7.5L10 12.5L15 7.5' stroke='%23484848' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
            background-repeat: no-repeat !important;
            background-position: right 12px center !important;
            padding-right: 40px !important;
        }

        div[class^="_selectContainer_"] p[class^="_label_"],
        div[class^="_selectContainer_"] p[class*="_label_"] {
            display: none !important;
        }

        button[class^="_selectToggle_"] {
            padding: 15px 40px 15px 15px !important;
            border: 0.5px solid #484848 !important;
            border-radius: 8px !important;
            background: #F6F5F2 !important;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
            box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05) !important;
            box-sizing: border-box !important;
            width: 100% !important;
            text-align: left !important;
            cursor: pointer !important;
            height: 60px !important;
            display: flex !important;
            align-items: center !important;
        }

        button[class^="_selectToggle_"] span[class^="_selectToggleText_"]:empty::before {
            content: "Select loading equipment" !important;
            color: #000000 !important;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
        }

        button[class^="_selectToggle_"] span[class^="_selectToggleText_"] {
            color: #212124 !important;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
            display: flex !important;
            align-items: center !important;
        }
        button[class^="_selectToggle_"] span[class^="_selectToggleText_"] {
            overflow: inherit !important;
        }
        span[class^="_arrowDownIcon_"] {
            position: absolute !important;
            right: 12px !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
        }

        div[class^="_selectContainer_"] {
            margin-bottom: 0px !important;
        }

        div[class^="_dropdownContainer_"] {
            top: 100% !important;
            bottom: auto !important;
            transform: none !important;
        }

        ul[class^="_selectDropdown_"] {
            max-height: 300px !important;
            overflow-y: auto !important;
            border: 0.5px solid #484848 !important;
            border-radius: 8px !important;
            background: #FFFFFF !important;
            box-shadow: 0px 4px 12px 0px rgba(10, 13, 18, 0.15) !important;
            margin-top: 4px !important;
            padding: 8px !important;
            box-sizing: border-box !important;
        }

        li[class^="_selectDropdownOption_"] {
            padding: 12px !important;
            border-radius: 4px !important;
            cursor: pointer !important;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
            color: #212124 !important;
            margin: 4px 0 !important;
            transition: background 0.2s ease !important;
        }

        li[class^="_selectDropdownOption_"]:hover {
            background: rgba(40, 82, 135, 0.1) !important;
        }

        li[class^="_selectDropdownOption_"][aria-selected="true"] {
            background: #285287 !important;
            color: #FFFFFF !important;
        }

        .store-lax li[class^="_selectDropdownOption_"][aria-selected="true"] {
            background: var(--lax-deep-crimson) !important;
        }

        .store-xtreme li[class^="_selectDropdownOption_"][aria-selected="true"] {
            background: var(--xtreme-deep-red) !important;
        }

        form[class^="_formFieldset_"] {
        display: block !important;
        }

        div[class^="_formFieldContainer_"] {
            width: 100% !important;
            margin-bottom: 0px !important;
            height: auto !important;
            min-height: 40px !important;
            position: relative !important;
            padding-bottom: 0px !important;
            vertical-align: top !important;
            box-sizing: border-box !important;
        }

        .first-two-fields-wrapper {
            display: flex !important;
            gap: 32px !important;
            width: 100% !important;
            margin-bottom: 0px !important;
            box-sizing: border-box !important;
        }
        ._formFieldContainer_1mxsl_5:has(textarea)::before {
            background-color: transparent !important;
        }
         
        .first-two-fields-wrapper div[class^="_formFieldContainer_"] {
            flex: 1 !important;
            width: 50% !important;
            margin-bottom: 0 !important;
            margin-right: 0 !important;
            padding-bottom: 0px !important;
            height: auto !important;
            min-height: 50px !important;
        }

        form[class^="_formFieldset_"] > div[class^="_formFieldContainer_"],
        form[class^="_formFieldset_"] > div[class^="_selectContainer_"],
        form[class^="_formFieldset_"] > fieldset[class^="_checkboxFieldSet_"],
        form[class^="_formFieldset_"] > .first-two-fields-wrapper {
            width: 100% !important;
            display: block !important;
            margin-bottom: 32px !important;
        }

        .first-two-fields-wrapper {
            display: flex !important;
        }

        div[class^="_formFieldContainer_"]:has(select) {
            width: 100% !important;
            display: block !important;
        }

        div[class^="_formFieldContainer_"]:has(textarea) {
            width: 100% !important;
            display: block !important;
        }
 
        div[class^="_formFieldContainer_"]:has(#company_name) {
        max-width: 100% !important;
        }

        div[class^="_formFieldContainer_"]:has(input[id="custom#mailing_address_1"]) {
            max-width: 100% !important;
            display: inline-block !important;
            vertical-align: top !important;
            width: 100% !important;
            margin-right: 0px !important;
        }



      label[class^="_formInputFieldLabel_"] {
      color:  #212124 !important;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
font-size: 16px !important;
font-style: normal;
font-weight: 400 !important;
line-height: 24px; 
letter-spacing: 0.1px !important;
      } 

      fieldset[class^="_checkboxFieldSet_"] {
      margin-bottom: 0px !important;
      }

      form[class^="_formFieldset_"] > fieldset[class^="_checkboxFieldSet_"] {
      margin-bottom: 32px !important;
      }

        button[type="submit"] {
            border-radius: 2px !important;
            border: 1px solid  #285287 !important;
            background-color: ${storeColor} !important;
            box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05);
            color: #FFFFFF !important;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
            font-size: 18px !important;
            font-style: normal;
            font-weight: 500;
            line-height: 28px; 
            padding: 16px 28px !important; 
            margin: 40px auto 0 auto !important;
        }


        [class^="_formFileInputField_"] {
        background: transparent !important;
                    border: 0.5px solid #484848 !important;
            box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05) !important;

        }

        [class^="_textBody_"] {
        color: var(--almost-black) !important;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
font-size: 18px !important;
font-style: normal;
font-weight: 400;
line-height: 28px;
letter-spacing: 0.1px !important;
}

[class^="_textBody_"] {
color:  #212124 !important;
 font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
font-size: 16px !important;
font-style: normal;
font-weight: 400;
line-height: 24px;
letter-spacing: 0.1px !important;
}

[class^="_textBody_"] p:last-child {
    color: var(--freedom-red) !important;
    font-size: 16px !important;
    margin-top: 4px !important;
}

.store-lax [class^="_textBody_"] p:last-child {
    color: var(--lax-deep-crimson) !important;
}

.store-xtreme [class^="_textBody_"] p:last-child {
    color: var(--xtreme-deep-red) !important;
}

[class^="_formFileInputButton_"] {
 background: rgba(140, 144, 128, 0.05) !important;
  font-size: 0px !important;
  border-radius: 50% !important;
  width: 39px !important;
    height: 39px !important;
    position: relative !important;
}

    [class^="_formFileInputButton_"]::before {
        content: " ";
        background-image: url('https://cdn.shopify.com/s/files/1/0887/1061/1314/files/upload.svg?v=1749072325');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 24px;
        height: 24px;
    }

    [class^="_formFileInputField_"]  {
       position: relative !important;
       min-height: 166px !important;
       align-items: center !important;
       padding: 32px 0 10px 0 !important;
      
    }

    [class^="_formFileInputField_"]::before {
        content: "If you have a tax exemption certificate please upload it here";
           position: absolute;
        top: 42px;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        color: var(--almost-black) !important;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
        font-size: 16px !important;
        margin-bottom: 24px !important;
}

[class^="_formFileInputButton_"] {
   margin-top: 24px !important;
}

[class^="_formFileInput_"] {
   margin-top: 40px !important;
}
 
div[class^="_formError_"],
div[class^="_error_"],
output[class^="_formError_"],
output[class^="_error_"] {
    position: absolute !important;
    bottom: -22px !important;
    left: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    color: var(--freedom-red) !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
    font-size: 14px !important;
    line-height: 16px !important;
}
@media (max-width: 749px) {
    div[class^="_formError_"],
    div[class^="_error_"],
    output[class^="_formError_"],
    output[class^="_error_"] {
        bottom: -17px !important;
    }
}
.store-lax div[class^="_formError_"] ,
.store-lax div[class^="_error_"],
.store-lax output[class^="_formError_"],
.store-lax output[class^="_error_"] {
    color: var(--lax-deep-crimson) !important;
    }

.store-xtreme div[class^="_formError_"],
.store-xtreme div[class^="_error_"],
.store-xtreme output[class^="_formError_"],
.store-xtreme output[class^="_error_"] {
    color: var(--xtreme-deep-red) !important;
    }

    div[class^="_formFieldContainer_"][class*="_withError_"] input[type="email"],
    div[class^="_formFieldContainer_"][class*="_withError_"] input:invalid {
        border-color: var(--freedom-red) !important;
    }

    .store-lax div[class^="_formFieldContainer_"][class*="_withError_"] input[type="email"],
    .store-lax div[class^="_formFieldContainer_"][class*="_withError_"] input:invalid {
        border-color: var(--lax-deep-crimson) !important;
    }

    .store-xtreme div[class^="_formFieldContainer_"][class*="_withError_"] input[type="email"],
    .store-xtreme div[class^="_formFieldContainer_"][class*="_withError_"] input:invalid {
    border-color: var(--xtreme-deep-red) !important;
    }



        @media (min-width: 1050px) {

            .first-two-fields-wrapper {
                flex-direction: row !important;
            }

            .first-two-fields-wrapper div[class^="_formFieldContainer_"] {
                flex: 1 !important;
                width: calc(50% - 16px) !important;
                max-width: calc(50% - 16px) !important;
                box-sizing: border-box !important;
            }

        div[class^="_formFieldContainer_"] input,
        div[class^="_formFieldContainer_"] select,
        div[class^="_formFieldContainer_"] textarea {
            max-width: 100% !important;
            width: 100% !important;
            box-sizing: border-box !important;
        }


        }
        form[class^="_formFieldset_"] > div[class^="_formFieldContainer_"] {
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            min-height: 50px !important;
        }

        @media (min-width: 750px) and (max-width: 1049px) {
            
            .first-two-fields-wrapper {
                flex-direction: column !important;
                gap: 32px !important;
                margin-bottom: 0px !important;
            }

            .first-two-fields-wrapper div[class^="_formFieldContainer_"] {
                width: 100% !important;
                max-width: 100% !important;
                margin-right: 0 !important;
                margin-bottom: 0 !important;
                box-sizing: border-box !important;
                padding-bottom: 0px!important;
            }


            form[class^="_formFieldset_"] > div[class^="_formFieldContainer_"],
            form[class^="_formFieldset_"] > div[class^="_selectContainer_"],
            form[class^="_formFieldset_"] > fieldset[class^="_checkboxFieldSet_"],
            form[class^="_formFieldset_"] > .first-two-fields-wrapper {
                width: 100% !important;
                max-width: 100% !important;
                margin-bottom: 32px !important;
            }

            div[class^="_formFieldContainer_"] input,
            div[class^="_formFieldContainer_"] select,
            div[class^="_formFieldContainer_"] textarea {
                max-width: 100% !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }
        }

            @media (max-width: 1099px) {
                h2[class^="_textHeading_"] {
                    font-family: Playfair !important;
                    color: #2B3729 !important; 
                    font-weight: 700;
                    font-size: 32px!important;
                    line-height: 40px!important;
                    text-align: start !important;
                }
            }
                
            @media (max-width: 1200px) {
            #form-container-ref section[data-sizing="form-wrapper"] form {
            padding: 0 !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
            }
            [class^="_textBody_"] {
                color:  #212124 !important;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
                font-size: 15px !important;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
                letter-spacing: 0.1px !important;
            }
            #form-container-ref section[data-sizing="form-wrapper"] {
                padding: 0 20px !important;
                box-sizing: border-box !important;
            }
            }

            @media (max-width: 750px) {
            #form-container-ref section[data-sizing="form-wrapper"] form {
            padding: 0  !important;
            max-width: 100% !important;
            width: 90vw !important;
            box-sizing: border-box !important;
            }

            #form-container-ref section[data-sizing="form-wrapper"] {
                padding: 0 !important;
                max-width: 100% !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }

            #app-embed {
                width: 100% !important;
                max-width: 100% !important;
            }

            .shopify-block.shopify-app-block,
            [data-form-root="true"] {
                width: 100% !important;
                max-width: 100% !important;
                padding: 0 !important;
            }
            }


            @media (max-width: 749px) {
                ._gridItem_1q1d2_172:nth-child(2) {
                    padding: 40px 30px;
                }
                       div[class^="_formFieldContainer_"] input, 
                       div[class^="_formFieldContainer_"] select, 
                       div[class^="_formFieldContainer_"] textarea {
                max-width: 100% !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }

            .first-two-fields-wrapper {
                flex-direction: column !important;
                gap: 20px !important;
                width: 100% !important;
                margin-bottom: 0px !important;
                box-sizing: border-box !important;
            }

            .first-two-fields-wrapper div[class^="_formFieldContainer_"] {
                width: 100% !important;
                max-width: 100% !important;
                margin-bottom: 0 !important;
                margin-right: 0 !important;
                box-sizing: border-box !important;
            }

            form[class^="_formFieldset_"] > div[class^="_formFieldContainer_"],
            form[class^="_formFieldset_"] > div[class^="_selectContainer_"],
            form[class^="_formFieldset_"] > fieldset[class^="_checkboxFieldSet_"],
            form[class^="_formFieldset_"] > .first-two-fields-wrapper {
                width: 100% !important;
                max-width: 100% !important;
                margin-right: 0 !important;
                margin-bottom: 20px !important;
                box-sizing: border-box !important;
            }

            .register-form-heading {
            font-size: 24px !important;
            line-height: 32px !important;
            margin-top: 20px !important;
            margin-bottom: 20px !important;
            
            }

            div[class^="_formFieldContainer_"] {
              margin-bottom: 0px !important;
              width: 100% !important;
              max-width: 100% !important;
              box-sizing: border-box !important;
            }

            div[class^="_formFieldContainer_"]:has(input[id="custom#mailing_address_1"]) {
            max-width: 100% !important;
            width: 100% !important;
            display: block !important;
            margin-right: 0 !important;
            }



            button[class^="_formSubmitButton_"] {
            font-size: 16px !important;
            padding: 12px 20px !important;
            width: 140px !important;
            }
     }


    .store-lax [class^="_textBody_"] p, 
    .store-lax [class^="_textBody_"] p a,
     .store-lax label[class^="_formInputFieldLabel_"],
     .store-lax [class^="_textBody_"],
      .store-lax [class^="_textBody_"] p{
         color: var(--lax-rich-black) !important;
    }

    .store-xtreme [class^="_textBody_"] p, 
    .store-xtreme [class^="_textBody_"] p a,
     .store-xtreme label[class^="_formInputFieldLabel_"],
     .store-xtreme [class^="_textBody_"],
      .store-xtreme [class^="_textBody_"] p{
         color: var(--xtreme-jet-black) !important;
    }


    
    `;
    shadowRoot.appendChild(style);
};

const wrapFirstTwoFields = (shadowRoot) => {
    const form = shadowRoot.querySelector('form[class^="_formFieldset_"]');
    if (!form) return;
    
    const fieldContainers = form.querySelectorAll('div[class^="_formFieldContainer_"]');
    if (fieldContainers.length < 2) return;
    
    const firstField = fieldContainers[0];
    if (firstField.parentElement.classList.contains('first-two-fields-wrapper')) return;
    
    const wrapper = document.createElement('div');
    wrapper.className = 'first-two-fields-wrapper';
    wrapper.style.cssText = `
        display: flex !important;
        width: 100% !important;
        flex-wrap: wrap !important;
    `;
    
    firstField.parentNode.insertBefore(wrapper, firstField);
    
    wrapper.appendChild(fieldContainers[0]);
    wrapper.appendChild(fieldContainers[1]);
};

const moveErrorMessages = (shadowRoot) => {
    const moveErrors = () => {
        const form = shadowRoot.querySelector('form[class^="_formFieldset_"]');
        if (!form) return;

        // Get all error messages in the form
        const allErrors = Array.from(form.querySelectorAll('output[class^="_formError_"]'));
        
        shadowRoot.querySelectorAll('div[class^="_formFieldContainer_"][class*="_withError_"]').forEach(field => {
            // Skip if already has error message inside
            if (field.querySelector('output[class^="_formError_"]')) return;
            
            // Get the input field to match with error message
            const input = field.querySelector('input, textarea, select');
            if (!input) return;
            
            const inputId = input.id;
            
            // Find matching error message that mentions this field
            const fieldLabel = field.querySelector('label')?.textContent.trim().toLowerCase() || '';
            
            // Look for error that's a sibling first
            let errorMsg = field.nextElementSibling;
            if (errorMsg && Array.from(errorMsg.classList).some(c => c.startsWith('_formError_'))) {
                field.appendChild(errorMsg);
                return;
            }
            
            // Otherwise, search through all errors for matching text
            for (const error of allErrors) {
                const errorText = error.textContent.toLowerCase();
                if (errorText.includes(fieldLabel)) {
                    field.appendChild(error);
                    break;
                }
            }
        });
    };

    moveErrors();
    
    const form = shadowRoot.querySelector('form');
    if (form) {
        new MutationObserver(() => moveErrors()).observe(form, {
            childList: true,
            subtree: true
        });
    }
};
 

const observer = new MutationObserver((mutations, obs) => {
    const formEmbed = document.querySelector('#app-embed');
    
    if (formEmbed && formEmbed.shadowRoot) {
        applyFormStyles(formEmbed.shadowRoot);
        wrapFirstTwoFields(formEmbed.shadowRoot);
        moveErrorMessages(formEmbed.shadowRoot);
        moveFieldContainer(formEmbed.shadowRoot);
 
        if (Object.values(headings).every(heading => heading.added)) {
            obs.disconnect();
        }
    }
});

observer.observe(document, {
    childList: true,
    subtree: true
});